<div class="main-form-container">
  <div class="tags-header">
    <h2 class="tags-header__text">{{ data.title }}</h2>
  </div>
  <form [formGroup]="inputForm" class="form mt-24">
    <div class="input-group --required">
      <label class="label">{{ data.label | translate }}</label>
      <input class="name mt-6" formControlName="input" id="name" type="text" />
    </div>
    <app-form-error [control]="inputForm.get('input')" [name]="'Tag' | translate"></app-form-error>
  </form>
  <div class="mt-24"></div>
  <app-button
    (click)="closeDialog('save')"
    [disabled]="inputForm.invalid || inputForm.pristine"
    [idleText]="(data.value ? 'Update' : 'Save') | translate"
    color="var(--white)"
    cssClass="button-primary button-full"
    size="large"
  ></app-button>
</div>
